export const debug = false;
export const backendServer = 'https://care-free.app';
export const gameServer = 'https://care-free.app';
export const publicBuildUrl = `${backendServer}/wp-content/plugins/miro-cares/build/`;
